export default "__VITE_ASSET__DDjyC8nT__"